import { render, staticRenderFns } from "./vBackButton.vue?vue&type=template&id=e7495172&scoped=true"
import script from "./vBackButton.vue?vue&type=script&lang=ts"
export * from "./vBackButton.vue?vue&type=script&lang=ts"
import style0 from "./vBackButton.vue?vue&type=style&index=0&id=e7495172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7495172",
  null
  
)

export default component.exports